import Select from 'react-select';
import styled from 'styled-components';

export const StyledSelect = styled(Select)(
  ({
    error,
    helperText,
    fullWidth,
    isSearchable,
    theme: {
      responsive: { mobile },
      border,
      spacing,
      font,
      colors,
    },
  }) => ({
    '.rs__control': {
      borderColor: error ? colors.error : colors.lightGrey,
      boxShadow: 'none',
      minHeight: 48,
    },
    '.rs__control--is-disabled .rs__single-value': {
      color: colors.disabled,
    },
    '.rs__control--menu-is-open, .rs__control--menu-is-open:hover': {
      borderColor: colors.primary,
    },
    '.rs__control:hover': {
      borderColor: colors.grey,
    },
    '.rs__dropdown-indicator path': {
      stroke: colors.grey,
    },
    '.rs__indicator-separator': {
      backgroundColor: colors.lightGrey,
    },
    '.rs__indicators': {
      cursor: 'pointer',
    },
    '.rs__multi-value': {
      background: colors.lightGrey,
      padding: 2,
    },
    '.rs__multi-value__label': {
      background: colors.primaryHighlight,
      color: colors.secondary,
    },
    '.rs__multi-value__remove': {
      background: colors.primaryHighlight,
      color: colors.secondary,
    },
    '.rs__multi-value__remove:hover': {
      background: colors.primaryHighlight,
      color: colors.secondaryTint,
      cursor: 'pointer',
    },

    '.rs__option': {
      '&:first-child': {
        marginTop: 0,
      },
      '&:last-child': {
        marginBottom: 0,
      },
      borderRadius: border.radius.sm,
      color: colors.secondary,
      cursor: 'pointer',
      fontSize: font.size.sm,
      lineHeight: font.lineHeight.sm,
      margin: spacing.xxs,
      width: `calc(100% - ${spacing.xxs} - ${spacing.xxs})`,
    },
    '.rs__option--is-selected, .rs__option--is-selected:hover': {
      background: colors.primary,
      color: colors.white,
    },
    '.rs__option:hover, .rs__option--is-focused': {
      background: colors.primaryHighlight,
      color: colors.primary,
    },
    '.rs__single-value': {
      color: colors.secondary,
      fontSize: font.size.sm,
      lineHeight: font.lineHeight.sm,
    },
    '.rs__value-container': {
      cursor: isSearchable ? 'text' : 'pointer',
    },
    flexShrink: 0,
    marginBottom: helperText ? spacing.sm : spacing.md,
    minHeight: 48,
    minWidth: 200,
    [mobile]: {
      minWidth: 175,
    },
    width: fullWidth ? '100%' : 'auto',
  }),
);

export const StyledHelperText = styled.small(
  ({ error, theme: { spacing, font, colors } }) => ({
    color: error ? colors.error : colors.darkGrey,
    display: 'block',
    fontSize: font.size.xs,
    fontWeight: font.weight.normal,
    lineHeight: font.lineHeight.xs,
    paddingBottom: spacing.md,
    width: '100%',
  }),
);
